import React, { FC } from "react";
import {
  ContentWrapper,
  Heading,
} from "containers/RightPanel/RightPanel.styles";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Content } from "../../../../components/Addresses/components/AddressForm.styles";
import Input from "../../../../components/Input/Input";
import { FieldWrapper } from "../../../../styles/formStyles";

interface PassportViewPanelProps {
  panelData: any;
  isOpen: boolean;
}

const PassportViewPanel: FC<PassportViewPanelProps> = ({ panelData }) => {
  const { t } = useTranslation("common");
  const passport = panelData.get("passport");

  return (
    <ContentWrapper>
      <Heading>{t("books.passports.viewPassport")}</Heading>
      <ViewContent>
        <Input
          label={t("books.passports.fullName")}
          value={passport.get("full_name")}
          disabled
        />
        <Input
          label={t("books.passports.dateOfBirth")}
          value={passport.get("date_of_birth")}
          disabled
        />
        <FieldWrapper>
          <Input
            label={t("books.passports.serial")}
            value={passport.get("serial")}
            disabled
          />
          <Input
            label={t("books.passports.number")}
            value={passport.get("number")}
            disabled
          />
        </FieldWrapper>
        <Input
          label={t("books.passports.issuedBy")}
          value={passport.get("issued_by")}
          disabled
        />
        <Input
          label={t("books.passports.registration")}
          value={passport.get("registration")}
          disabled
        />
        <Input
          label={t("books.passports.taxId")}
          value={passport.get("tax_id")}
          disabled
        />
        <Input
          label={t("books.passports.issuedDate")}
          value={passport.get("issued_date")}
          disabled
        />
      </ViewContent>
    </ContentWrapper>
  );
};

export default PassportViewPanel;

const ViewContent = styled(Content)`
  label {
    margin-bottom: 10px;
  }
`;
